import React, { ReactElement } from 'react';
import { isMobile } from '../../../services/deviceService';

type Props = {
  removeChip: () => void,
  name: string,
};

function Chip(props: Props): ReactElement {
  const isExpandButton = props.name.slice(0, 1) === '+';
  return isExpandButton ? (
    <button
      type="button"
      className="chip-container"
      onClick={props.removeChip}
    >
      <span>{props.name}</span>
    </button>
  ) : (
    <div
      className="chip-container"
      onClick={() => {
        if (isMobile) props.removeChip();
      }}
    >
      <span>{props.name}</span>
      {isExpandButton || (
        <button
          type="button"
          className="remove-chip-button"
          onClick={props.removeChip}
        >
          <i className="fa fab fa-times" />
        </button>
      )}
    </div>
  );
}

export default Chip;
